/* eslint arrow-parens:0 */

import React, { Component } from 'react';
import BoardCard from 'app/common/react/components/BoardCard/BoardCard';
import CONST from 'app/common/lib/Const';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import { Box, Spinner } from 'gestalt';

export default class UnauthBoardsList extends Component {
  static propTypes = {
    boards: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        owner: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }).isRequired,
      }),
    ),
    isRetina: PropTypes.bool.isRequired,
    resourceLoaded: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    boards: [],
  };

  state = {
    boards: this.props.boards,
  };

  UNSAFE_componentWillReceiveProps({ boards, resourceLoaded }) {
    if (resourceLoaded) {
      this.setState({ boards });
    }
  }

  render() {
    const { isRetina, resourceLoaded, seoUnauthExperiments } = this.props;

    if (!resourceLoaded) {
      return (
        <div style={{ marginTop: 200 }}>
          <Spinner accessibilityLabel={i18n._('Board list')} show />
        </div>
      );
    }

    const { boards } = this.state;
    return (
      <div data-test-id="profileboards" className="userBoards">
        <div className="Grid">
          <div className="GridItems centeredWithinWrapper padItems mb4">
            <Box display="flex" wrap>
              {boards.map((board, index) => (
                <Box display="inlineBlock" paddingX={3} paddingY={2} key={index}>
                  <BoardCard
                    board={board}
                    isMobile={false}
                    isRetina={isRetina}
                    isUnauthProfileLanding
                    privacy={CONST.BoardPrivacy.PUBLIC}
                    showAuthorProfile
                    seoUnauthExperiments={seoUnauthExperiments}
                  />
                </Box>
              ))}
            </Box>
          </div>
        </div>
      </div>
    );
  }
}
